
export default function Footer() {
  return (
    <footer className="bg-amber-600 text-white py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <img 
              src="https://static.readdy.ai/image/e054c862bb8832d032cf0cf58507f2c7/c2b142d97304902a971209e1dcb8c95b.png"
              alt="RetroFlavor DF"
              className="h-20 mb-4"
            />
            <p className="text-amber-50 text-sm leading-relaxed">
              Sabores artesanais que aquecem o coração. Feito com carinho e ingredientes selecionados.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Contato</h4>
            <div className="space-y-3 text-amber-50 text-sm">
              <a 
                href="https://wa.me/5561999999999" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-white transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl w-6 h-6 flex items-center justify-center"></i>
                <span>WhatsApp</span>
              </a>
              <a 
                href="https://instagram.com/retroflavordf" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-white transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-xl w-6 h-6 flex items-center justify-center"></i>
                <span>@retroflavordf</span>
              </a>
            </div>
          </div>

          {/* Info */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Informações</h4>
            <div className="space-y-2 text-amber-50 text-sm">
              <p>RETROFLAVOR LANCHES LTDA</p>
              <p>CNPJ: 63.970.264/0001-98</p>
            </div>
          </div>
        </div>

        <div className="border-t border-amber-500 pt-6 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-amber-50">
          <p>© 2024 RetroFlavor. Todos os direitos reservados.</p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:text-white transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
